import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { Menu } from "./features/menu/Menu";
import { Rapports } from "./features/rapports/Rapports";
import { Dashboard } from "./features/dashboard/Dashboard";
import { Services } from "./features/services/Services";
import { RapportFinancier } from "./features/rapportfinancier/RapportFinancier";
import { Connexion } from "./features/connexion/Connexion";
import { Cumul } from "./features/cumul/Cumul";
import { Admin } from "./features/admin/Admin";
import ResetPassword from "./features/resetPassword/ResetPassword";
import ResetAlias from "./features/resetAlias/ResetAlias";
import PrivateRoute from "./components/PrivateRoute";
import history from "./history";
import { useSelector } from "react-redux";

import "./App.css";
import ListeRestaurants from "./features/listeRestaurants/ListeRestaurants";

export const App = () => {
  const utilisateur = useSelector((state) => state.connexion.utilisateur);
  return (
    <div className="App">
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Redirect exact to="/connexion" />}
          />
          <PrivateRoute
            path="/dashboard"
            component={() => (
              <>
                <Menu />
                <Dashboard />
              </>
            )}
          />
          <PrivateRoute
            path="/services"
            component={() => (
              <>
                <Menu />
                <Services />
              </>
            )}
          />
          <PrivateRoute
            path="/service/rapports"
            component={() => (
              <>
                <Menu />
                <Rapports />
              </>
            )}
          />
          <PrivateRoute
            path="/rapport/financier"
            component={() => (
              <>
                <Menu />
                <RapportFinancier />
              </>
            )}
          />
          <Route path="/connexion/:rest_id">
            <Connexion />
          </Route>
          <Route path="/connexion">
            <Connexion />
          </Route>
          <PrivateRoute
            path="/cumul"
            component={() => (
              <>
                <Menu />
                <Cumul />
              </>
            )}
          />
          <PrivateRoute
            path="/resetpassword"
            component={() => (
              <>
                <Menu />
                <ResetPassword />
              </>
            )}
          />
          <PrivateRoute
            path="/resetalias"
            component={() => (
              <>
                <Menu />
                <ResetAlias />
              </>
            )}
          />
          <PrivateRoute
            path="/listerestaurants"
            component={() => (
              <>
                <Menu />
                <ListeRestaurants />
              </>
            )}
          />
          <PrivateRoute
            exact
            path="/admin"
            component={() => (
              <>
                <Menu />
                {utilisateur.type === "superadmin" ? <Admin /> : <Redirect exact to="/dashboard" />}
              </>
            )}
          />
        </Switch>
      </Router>
    </div>
  );
};
